import React from 'react';
import Component from './Component';
import TextInput from './TextInput';

export default class FilterInput extends React.Component {

	static filterDelay = true;

	render() {
		return <div>
			<TextInput {...this.props} style={{...this.props.style, textOverflow: 'ellipsis'}} clearable={true} />
		</div>;
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/FilterInput.js